import {handleApiAction} from "utils/actions";
import {externalClient} from "utils/clients";

export default ({dispatch, getState}) => next => async action => {
    const {type, payload} = action;

    if (type === "COMMON:FETCH-MY-IP") {
        if (!getState().common.myIp) {
            handleApiAction(action, () => externalClient.get('https://api.ipify.org?format=json'))
        }
    } else if (type === "COMMON:VALIDATE-AGENT-LAST-RUN") {
        let lastRunData = getState().common?.lastRunData;
        const lastRun = new Date().toISOString();
        if (!lastRunData) {
            lastRunData = [];
            lastRunData.push({ "agentId": payload?.agentId, lastRun });
        } else {
            const lastRunAgent = lastRunData.find(x => x.agentId === payload?.agentId);
            if (lastRunAgent) {
                lastRunAgent.lastRun = lastRun;
            } else {
                lastRunData.push({ "agentId": payload?.agentId, lastRun });
            }
        }

        dispatch({
            type: "COMMON:VALIDATE-AGENT-LAST-RUN-SUCCESS",
            payload: {
                lastRunData
            }
        });
    }

    return next(action);
}
